/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgTag(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M1.664 2.417a.75.75 0 01.75-.75h10a.75.75 0 01.53.22l8.592 8.591a2.75 2.75 0 010 3.877l-.002.002-7.17 7.17a2.75 2.75 0 01-3.89 0l-8.59-8.58a.75.75 0 01-.22-.53v-10zm1.5.75v8.939l8.37 8.36a1.255 1.255 0 001.364.272 1.25 1.25 0 00.406-.271l7.168-7.169a1.253 1.253 0 000-1.762l-8.369-8.37H3.165zm3.5 4.25a.75.75 0 01.75-.75h.01a.75.75 0 110 1.5h-.01a.75.75 0 01-.75-.75z'
      />
    </svg>
  );
}

export default SvgTag;
